<template>
    <div class="mobile__nav">
        <li class="mobile__nav-item" v-if="isFrancoCountry">
            <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.93 3.336l.015.111-.167.035-.022.237h.2l.266-.026.137-.163-.146-.057-.08-.091-.12-.195-.057-.275-.226.046-.063.097v.11l.109.074.155.097z"
                    fill="#858585"
                />
                <path
                    d="M10.738 3.427l.012-.148-.132-.058-.185.043-.137.22v.143h.16l.282-.2zM6.928 4.059l-.04.105H6.69v.101h.046l.007.05.121-.01.076-.047.02-.094.097-.009.039-.08-.09-.018-.079.002zM6.42 4.243l-.007.1.142-.012.015-.1-.086-.067-.064.08z"
                    fill="#858585"
                />
                <path
                    d="M14.998 7.422a7.452 7.452 0 00-.53-2.694c-.019-.047-.037-.096-.057-.143a7.508 7.508 0 00-1.866-2.63A7.472 7.472 0 007.5 0a7.47 7.47 0 00-5.078 1.986c-.311.287-.598.6-.857.936A7.46 7.46 0 000 7.5C0 11.635 3.365 15 7.5 15A7.506 7.506 0 0015 7.5l-.002-.077zm-1.411-2.998l.043-.048c.057.11.11.223.162.337l-.071-.003-.134.019v-.305zm-1.084-1.308l.001-.335c.118.125.232.253.34.387l-.135.2-.472-.003-.03-.099.296-.15zm-9.047-.833v-.012h.15l.013-.052h.246v.107l-.07.095h-.34v-.138zm.24.335s.15-.026.163-.026c.013 0 0 .15 0 .15l-.339.022-.064-.078.24-.068zm10.369 2.977h-.55l-.334-.249-.352.034v.215h-.11l-.121-.086-.61-.154V4.96l-.772.06-.24.129h-.306l-.15-.015-.373.206v.39l-.76.548.062.235h.155l-.04.223-.11.04-.005.584.657.749h.287l.017-.046h.514l.149-.137h.292l.16.16.435.045-.058.579.483.852-.254.486.017.229.2.2v.55l.263.353v.457h.227A6.873 6.873 0 017.5 14.383 6.89 6.89 0 01.617 7.498c0-.955.196-1.866.55-2.693V4.59l.246-.299c.085-.161.177-.319.274-.472l.012.125-.286.347a6.827 6.827 0 00-.247.514v.392l.287.137v.545l.274.468.223.034.029-.16-.263-.407-.052-.394h.154l.065.406.38.555-.097.18.241.369.601.149v-.098l.24.035-.022.171.188.035.292.08.412.469.526.04.051.428-.36.252-.017.383-.051.235.52.652.04.223s.189.051.212.051c.023 0 .423.303.423.303v1.179l.143.04-.097.543.24.32-.044.54.317.557.408.356.41.008.04-.132-.301-.254.017-.125.054-.155.011-.157-.203-.006-.103-.129.169-.163.023-.122-.189-.054.011-.115.27-.04.408-.197.137-.252.43-.549-.098-.429.132-.229.394.012.266-.21.086-.829.294-.374.052-.24-.269-.086-.177-.291-.606-.006-.481-.183-.023-.343-.16-.28-.435-.007-.251-.394-.223-.11-.011.121-.406.024-.15-.207-.423-.086-.349.403-.549-.093-.04-.619-.4-.068.16-.304-.045-.174-.527.352-.331-.04-.119-.26.073-.266.182-.337.42-.213h.813l-.002.248.291.136-.023-.424.21-.211.425-.28.03-.195.422-.44.45-.25-.04-.033.305-.287.112.03.051.064.116-.128.028-.013-.126-.018-.13-.043V3.7l.07-.056h.15l.068.03.06.12.072-.01v-.011l.021.007.211-.032.03-.103.12.03v.112l-.111.076.017.123.382.118v.004L7.71 4.1l.006-.166-.303-.138-.018-.08.252-.085.01-.24-.262-.16-.017-.406-.36.177h-.132l.035-.31-.49-.115-.204.154v.467l-.365.116-.146.305-.159.025v-.39l-.343-.047-.171-.112-.07-.252.614-.36.3-.09.03.2.168-.008.013-.101.175-.025.003-.036-.075-.03-.018-.108.215-.018.13-.136.007-.01.002.001.04-.04.451-.058.2.17-.524.28.667.157.086-.223h.292l.103-.195-.206-.051v-.246L7 1.63l-.446.051-.252.132.017.32-.263-.04-.04-.177.252-.229-.458-.023-.131.04-.057.154.171.03-.034.17-.292.018-.045.114-.423.012s-.012-.24-.029-.24l.332-.006.252-.246-.138-.069-.183.178L4.93 1.8l-.183-.251h-.39l-.405.303h.372l.034.109-.097.09.412.011.063.149-.464-.018-.022-.114-.292-.063-.154-.086-.347.003A6.845 6.845 0 017.5.616c1.74 0 3.33.651 4.544 1.72l-.082.146-.317.125-.134.145.03.17.165.022.098.247.283-.114.046.33h-.085l-.232-.034-.257.043-.249.352-.356.056-.051.304.15.036-.044.196-.353-.071-.324.07-.07.181.057.379.19.09.32-.003.215-.02.066-.17.337-.438.222.045.218-.197.04.154.538.362-.066.088-.242-.013.093.133.15.032.174-.073-.004-.21.078-.039-.063-.066-.358-.2-.094-.265h.298l.095.094.257.221.01.268.266.283.1-.388.183-.1.035.317.18.197.359-.006c.069.179.131.36.186.546l-.037.034zM4.09 3.407l.18-.086.163.04-.056.218-.176.056-.111-.228zm.956.515v.142h-.412l-.154-.043.039-.1.197-.08h.27v.08h.06zm.19.197v.138l-.104.066-.128.024v-.228h.231zm-.117-.055V3.9l.142.13-.142.034zm.065.33v.133l-.099.099h-.218l.034-.15.103-.009.022-.051.158-.022zm-.545-.275h.227l-.291.408-.12-.065.025-.171.159-.172zm.931.228v.133h-.219l-.06-.086V4.27h.018l.261.077zm-.202-.184l.062-.065.105.065-.084.07-.083-.07zm8.807 1.78l.022-.026.027.117-.049-.091z"
                    fill="#858585"
                />
                <path
                    d="M1.167 4.591v.215c.075-.175.157-.346.246-.514l-.246.3z"
                    fill="#858585"
                />
            </svg>
            <!-- <h5 class="language">ENGLISH (CHANGE)</h5> -->
            <locale-switcher 
                class="language"
                @toggle-locale="handleLocaleChange"
            />
        </li>
        <li role="button" class="mobile__nav-item" @click="$emit('change-method')">
            <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)" fill="#000" fill-opacity=".4">
                    <path
                        d="M8.657 17.292a6.976 6.976 0 007.418-3.112l-.909-.566a5.89 5.89 0 01-10.88-3.422l1.612 1.476.724-.79L4.25 8.706a.536.536 0 00-.757.033l-2.172 2.372.79.724 1.097-1.197a6.971 6.971 0 005.45 6.654zM13.707 10.107l2.372 2.172c.218.2.557.185.757-.033l2.172-2.372-.79-.724-1.097 1.197A6.96 6.96 0 004.255 6.804l.908.567a5.89 5.89 0 0110.88 3.422l-1.612-1.476-.724.79z"
                    />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <path
                            fill="#fff"
                            transform="rotate(102.5 8.533 10.137)"
                            d="M0 0h17v17H0z"
                        />
                    </clipPath>
                </defs>
            </svg>
            <p class="change-payment">{{ translate("ui.change.payment.options", "Change payment method")}}</p>
        </li>
        <!-- <li role="button" @click="handleCloseIframe" class="mobile__nav-item">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
                <path
                    d="M5.884 5l3.933-3.93a.625.625 0 10-.885-.885L5 4.117 1.068.184a.625.625 0 10-.885.885L4.116 5 .183 8.933a.625.625 0 10.885.884L5 5.885l3.932 3.932a.624.624 0 00.885 0 .625.625 0 000-.884L5.884 5.001z"
                    fill="#000"
                    fill-opacity=".4"
                />
            </svg>
            <p @click="handleCloseIframe" class="close">Cancel Payment</p>
        </li> -->
    </div>
</template>

<script>
import { ref, onBeforeUnmount, computed } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
import LocaleSwitcher from "@/components/locale-switcher.vue";

export default {
    name: "MobileNavigation",
    components: {
        LocaleSwitcher,
    },
    emits: ["change-method"],
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        const currency = ref(
            getValueFromPath(
                checkoutData.value,
                "currency.current",
            ) || null,
        );
        onBeforeUnmount(() => {
            subscription();
        });

        const isFrancoCountry = computed(() => {
            switch (currency.value) {
            case "XAF":
            case "XOF":
            case "CFA":
            case "BRL":
            case "AOA":
            case "CVE":
            case "MZN":
            case "STN":
            case "USD":
            case "EUR":
            case "GBP":
                return true;
            default:
                return false;
            }
        });

        function handleLocaleChange(locale) {
            store.CurrentLocale.switch(locale);
        }

        function handleCloseIframe(state) {
            store.Control.close(state);
        }
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
            }),
            handleCloseIframe,
            handleLocaleChange,
            isFrancoCountry,
        };
    },
};
</script>